import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { Component } from 'react'

export default class SwitchComponent extends Component {

  handleChange = (event) => {
    if (this.props.onChange) {
      this.props.onChange(event.target.checked);
    }
  };

  render() {
    return (
      <FormControlLabel
        control={
          <Switch
            checked={this.props.checked}
            onChange={this.handleChange}
            name="switchFmilia"
            color="primary"
          />
        }
        label={this.props.etiqueta}
      />

    );
  }
}
